<template>
  <div class="layout">
    <Layout :style="{ minHeight: '100vh' }">
      <Sider collapsible :collapsed-width="78" v-model="isCollapsed" width="240">
        <Menu
          :active-name="activeName"
          theme="dark"
          width="auto"
          :class="menuitemClasses"
        >
          <p v-if="!isCollapsed">中铁桥隧招标网</p>
          <img v-else src="@/assets/imgs/logo3.png" alt="" class="logo_img">
          <MenuItem name="1" to="projectInfo">
            <Icon type="ios-paper" :class="isCollapsed?'item_icon':''" />
            <span v-if="!isCollapsed">项目信息</span>
          </MenuItem>
          <MenuItem name="2" to="myProject">
            <Icon type="ios-people" :class="isCollapsed?'item_icon':''" />
            <span v-if="!isCollapsed">我的项目</span>
          </MenuItem>
        </Menu>
      </Sider>
      <Layout>
        <Header
          :style="{
            background: '#fff',
            boxShadow: '0 2px 3px 2px rgba(0,0,0,.1)',
          }"
        >
          <Tooltip content="修改密码" placement="bottom">
            <img @click="openChangePwd" src="@/assets/imgs/user.png" alt="">
          </Tooltip>
          <span>{{loginName}}</span>
          <Icon type="md-power" @click="logout"/>
        </Header>
        <Content :style="{ padding: '16px' }">
          <Tabs type="card" :value="activeTab" closable @on-click='val => $router.push({path: val})' @on-tab-remove="handleTabRemove">
            <TabPane :label="i.name" v-for="i in openTab" :key="i.path" :name="i.path"></TabPane>
          </Tabs>
          <router-view />
        </Content>
      </Layout>
    </Layout>
    <ChangePwd ref="changePwd"></ChangePwd>
  </div>
</template>
<script>
import ChangePwd from '@/components/ChangePwd'
export default {
  components: {
    ChangePwd
  },
  data() {
    return {
      isCollapsed: false,
      activeName: '1',
      // openTab: [],
      // activeTab: ''
    }
  },
  computed: {
    menuitemClasses: function () {
      return [
        'menu-item',this.isCollapsed ? 'collapsed-menu' : ''
      ]
    },
    loginName () {
      return JSON.parse(sessionStorage.getItem("user")).name
    },
    openTab () {
      return this.$store.state.openTabs
    },
    activeTab: {
      get () {
        return this.$store.state.activeTab
      },
      set (val) {
        this.$store.commit('setActiveTab', val)
      }
    }
  },
  watch: {
    '$route' (to,form) {
      this.activeName = to.meta.moduleId || '1'
      let flag = false
      for(let item of this.openTab){
        if(item.path === to.fullPath){
          this.$store.commit('setActiveTab',to.fullPath)
          flag = true
          break
        }
      }
      if(!flag){
        this.$store.commit('addTabs', Object.assign({},to.meta,{ path:to.fullPath}))
        this.$store.commit('setActiveTab', to.fullPath)
      }
    }
  },
  created () {
    this.$store.commit('addTabs', Object.assign({},this.$route.meta,{path:this.$route.fullPath}))
    this.$store.commit('setActiveTab', this.$route.fullPath)
    if(this.$route.path !== '/SystemHome/projectInfo' && this.$route.path !== '/SystemHome'){
      this.$store.commit('addTabs', {moduleId: '1',name: '项目信息',path: '/SystemHome/projectInfo'})
    }else {
      this.$router.push('/SystemHome')
    }
  },
  methods: {
    logout () {
      this.$Modal.confirm({
          title: '退出登录',
          content: '是否确认退出？',
          onOk: () => {
            this.$store.commit('removeLoginInfo')
            this.$router.push('/')
          }
      })
    },
    openChangePwd() {
      this.$refs['changePwd'].modal = true
    },
    handleTabRemove (name) {
      if(name === '/SystemHome/projectInfo' || name === '/SystemHome'){
        return 
      }
      this.$store.commit('deleteTabs', name)
      if (this.activeTab === name) {
        if (this.openTab && this.openTab.length >= 1) {
          this.$store.commit('setActiveTab', this.openTab[this.openTab.length-1].path)
          this.$router.push({path: this.activeTab})
        } else {
          this.$router.push({path: '/SystemHome'})
        }
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.ivu-layout-sider {
  background: #315FAC;
  ::v-deep .ivu-layout-sider-trigger,::v-deep .ivu-menu-dark {
    background: #315FAC;
  }
  .ivu-menu {
    color: #fff;
    font-size: 18px;
    p {
      font-size: 26px;
      font-weight: 500;
      color: #FFF;
      height: 75px;
      line-height: 75px;
      text-align: center;
    }
    .ivu-menu-item {
      font-size: 18px;
      .item_icon {
        font-size: 24px;
        margin-right: 0
      }
    }
  }
}
.ivu-layout-header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #333;
  font-size: 22px;
  span {
    font-size: 12px;
    margin: 0 30px 0 12px;
  }
  img,.ivu-icon {
    cursor: pointer;
  }
}
.ivu-tabs{
  color: #666;
  ::v-deep .ivu-tabs-bar{
    border-bottom: none;
  }
}
::v-deep.ivu-tabs.ivu-tabs-card>.ivu-tabs-bar{
  .ivu-tabs-tab{
    background:#fff;
    border: 1px solid #999;
    border-bottom:1px solid #999;
    border-radius: 5px 5px 0 0;
    margin-right: 0;
  }
  .ivu-tabs-tab-active{
    background: #1890FF;
    border: 1px solid #1890FF;
    color: #fff;
    .ivu-tabs-close{
      color: #fff;
    }
  }
}
.logo_img {
  width: 52px;
  margin-left: 11px;
  margin-top: 4px;
  padding-top: 2px;
}
</style>